<template>
  <div id="app" class="grid h__fixed main">
    <div class="gbox__inner fx_ctr h__fixed">
      <div class="subcol h__fixed">
        <div :class="{gnav__box:true, h__fixed:true, menu__open: menuOpen}">
          <GlobalMenu />
          <GlobalMenuBtm />
        </div>
      </div>
      <input type="checkbox" id="sp__slide" ref="sp__slide" :checked="spSlide" class="hide">
      <router-view/>
    </div>
    <div class="sp__arw__btn">
      <button @click="setSpMenu()" aria-label="back to previous page">
       <ArrowBtn :spSlide="spSlide" />
      </button>
    </div>
    <ComposePot v-if="composePot" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ComposePot from '@/components/ComposePot.vue';
import GlobalMenu from '@/components/Common/GlobalMenu.vue';
import GlobalMenuBtm from '@/components/Common/GlobalMenuBtm.vue';
import ArrowBtn from '@/components/Atoms/ArrowBtn.vue';
import Gdfs from "gdrive-fs";
import { importDB } from "dexie-export-import";


export default {
  data() {
    return {
      menuStatus: false,
      isGoogleSignin: false,
      fileStat: ''
    }
  },
  components: {
    ComposePot,
    GlobalMenu,
    GlobalMenuBtm,
    ArrowBtn
  },
  created(){
    // this.checkUpdate()
    this.composePotHandler(this.$route)
  },
  async mounted(){
    // 自動同期をオンにしていたら
    // this.restoreCloud()

  },
  watch: {
    '$route' (to) {
      this.composePotHandler(to)
      this.menuOpen = false
    }
  },
  computed: {
    ...mapGetters([
      'spSlide', 'composePot'
    ]),
    menuOpen: {
      get: function () {
        return this.menuStatus
      },
      set: function (val) {
        if(val === 'toggle'){
          this.menuStatus = this.menuStatus? false: true;
        }else{
          this.menuStatus = val;
        }
      }
    }
  },
  methods: {
    ...mapActions([
      "toggleSpSlide", 'toggleComposePot'
    ]),
    // testPush: async function(){
    //   Notification.requestPermission();
    //   new Notification("Hi there!");
    // },
    composePotHandler(route){
      if(route.name === 'ComposePot') this.toggleComposePot(true)
    },
    setSpMenu(){
      if(this.spSlide){
        this.menuOpen = false
        this.toggleSpSlide()
      }else{
        this.menuOpen = 'toggle'
      }
    },
    checkSignin: async function() {
      const params = {};
      params.clientId =
        "181186523944-rpmtnlr14lbtheirm6q5i6jgvil1ulsp.apps.googleusercontent.com";
      params.clientSecret = "sL8WHq8Bs3FKDljPRdX42Q6n";
      params.discoveryDocs = [
        "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
      ];
      params.scope = ["https://www.googleapis.com/auth/drive.appdata"].join(
        " "
      );
      await Gdfs.loadApi(params);

      this.isGoogleSignin = await Gdfs.isSignedIn();
    },
    syncCloud(){
      setInterval(function () {
      console.log('30秒毎に処理')
      if(this.isGoogleSignin){
        console.log('start sync sequence...');
        this.restoreCloud();
      }
      }.bind(this), 30000)
    },
    restoreCloud: async function() {
      const apiParams = {};
      apiParams.clientId =
        "181186523944-rpmtnlr14lbtheirm6q5i6jgvil1ulsp.apps.googleusercontent.com";
      apiParams.clientSecret = "sL8WHq8Bs3FKDljPRdX42Q6n";
      apiParams.discoveryDocs = [
        "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
      ];
      apiParams.scope = ["https://www.googleapis.com/auth/drive.appdata"].join(
        " "
      );
      await Gdfs.loadApi(apiParams);


      // localDBの日付チェック
      const dbupdate = await this.$db.pots
        .orderBy("updated_at")
        .desc()
        .toArray();
      const localLastUpdate = dbupdate.length > 0 ? dbupdate[0].updated_at : null;
      // console.log(localLastUpdate);

      // gdriveの日付チェック
      const params = {
        spaces: "appDataFolder",
        fields: "nextPageToken, files(id, name, modifiedTime)",
        pageSize: 100,
        orderBy: "modifiedTime desc"
      };

      const dir = await Gdfs.getFileList(params);
      if (dir.files.length === 0) {
        this.fileStat = await Gdfs.createFile("appDataFolder", "potly_db.json");
      } else {
        this.fileStat = dir.files[0];
      }

      // ローカルデータがなかったら自動でクラウドから同期
      if(localLastUpdate === null){
        this.doDownload();
      }
    },
    doDownload: async function() {
      // console.log(Gdfs.isSignedIn());

      const dbData = await Gdfs.downloadFile(this.fileStat.id);
      await this.$db.delete();
      await importDB(new Blob([dbData], { type: "text/plan" }));
      this.message = "復元が完了しました。";
      window.location.reload();
    },
    checkUpdate: async function(){
      const version = await fetch('https://status.510052.xyz/')
      .then(function(response) {
        return response.json()
      });
      const localVer = localStorage.getItem('version');
      // const lastUpdated = localStorage.getItem('lastUpdated');
      if(!localVer){
        localStorage.setItem('version', version.version);
      }else{
        if(localVer !== null && version.version !== localVer){
          alert('アップデートが見つかりました。アプリを更新します。')
          window.navigator.serviceWorker.getRegistrations()
          .then(registrations => {
            for(let registration of registrations) {
              registration.unregister();
            }
          });
          localStorage.setItem('version', version.version);
          window.location.reload(true);
        }
      }
    }
  }
}
</script>

<style lang="scss">
.gnav__box{
  background: #096321;
  transition: ease all .5s;
  position: absolute;
  top: 0;
  width: 100%;
  overflow: hidden;
  padding: 8px 0;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  &:hover{
    @media screen and (min-width: 648px){
      width: 160px;
      z-index: 9999;
    }
  }
  &.menu__open{
    @media screen and (max-width: 648px){
      width: 160px;
      z-index: 9999;
    }
  }
}
.gnav{
  li{
    a{
      color: #FFF;
      text-decoration: none;
      width: 100%;
      &:hover{
        background: #0c872d;
      }
      .icon{
        font-size: 1.1rem;
        width: 48px;
        min-width: 48px;
        height: 48px;
        padding: 9px;
        justify-content: center;
        position: relative;
        &.notice{
          &:after{
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #FF3300;
            position: absolute;
            top: 9px;
            right: 9px;
          }
        }
        &.stong{
          background: #0fa939;
          margin: 6px 20px 6px 6px;
          width: 36px;
          min-width: 36px;
          height: 36px;
          border-radius: 6px;
        }
      }
      .txt{
        white-space: nowrap
      }
    }
  }
}
.menu{
  &.back {
    .border {
      fill: rgb(137, 10, 12);
    }
    .border1 {
      transform: rotate(-45deg) translateY(80px) translateX(-200px);
      stroke-width: 12;
    }
    .border3 {
      transform: rotate(45deg) translateY(-220px) translateX(180px);
    }
  }
}
.border{
  fill: rgb(0, 0, 0);
  transition: 200ms all ease;
  transform-origin: 12px 12px;
}
.sp__arw__btn button:focus {outline:0;}
</style>
